// extracted by mini-css-extract-plugin
export default {"root":"_1PL_V","variant-subscriptions":"_22cax","variantSubscriptions":"_22cax","variant-adoptables":"_1zsrt","variantAdoptables":"_1zsrt"};